import { render, staticRenderFns } from "./ViewPop.vue?vue&type=template&id=1211d74c&"
import script from "./ViewPop.vue?vue&type=script&lang=js&"
export * from "./ViewPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports